// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_56_4J","horizontal":"_2fcZ4","illustration":"_35bqb","main":"_35tad","content":"_3-1DQ","close-button":"_1v8Js","closeButton":"_1v8Js"};